"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("../../../../constants/propTypes"));

var _SectionHeader = require("./SectionHeader.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The section header is often used on summary screens.
 * It may be a common need to place a `<br />` tag preceding this component to obtain correct padding/placement.
 */
var SectionHeader = function SectionHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_SectionHeader.Wrapper, null, /*#__PURE__*/_react.default.createElement(_SectionHeader.StyledPrimaryText, {
    dataTestId: "section-header"
  }, children), /*#__PURE__*/_react.default.createElement(_SectionHeader.StyledDivider, null));
};

SectionHeader.propTypes = {
  /** Text to display for the header (components are supported but not recommended) */
  children: _propTypes.default.children.isRequired
}; // SectionHeader.defaultProps = {};

var _default = SectionHeader;
exports.default = _default;